import { of } from "rxjs";

export const initialDataResolver = () => of(null);
